// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const UpsellStatusContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-upsellstatuscontainer" */ "./UpsellStatusContainer")).then((bundle)=>{
        return {
            default: bundle.UpsellStatusContainer
        };
    });
export const LazyUpsellStatusContainer = /*#__PURE__*/ lazy(UpsellStatusContainerLazyLoader);
